require('./bootstrap');

require('./my_component')
require('./my_component_en')